module.exports = __webpack_public_path__ + "img/home-but2.0625dc16.png";